<ph-dialog open [heading]="data.title" (ph-close)="_dialogRef.close()">
    <ph-facts value-align="end" label-width="150px">
        <ph-fact>
            <ph-label>Vendor</ph-label>
            <div>{{ data.vendorName }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Invoice Total</ph-label>
            <div>{{ data.invoiceTotal | legfiCurrency:'USD':'symbol':'.2' }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Payment Amount</ph-label>
            <div>
                {{ data.paymentAmount | legfiCurrency:'USD':'symbol':'.2' }}
                <ph-badge *ngIf="data.paymentAmount < data.invoiceTotal" variant="light" color="orange">Partial Payment</ph-badge>
                <ph-badge *ngIf="data.paymentAmount > data.invoiceTotal" variant="light" color="orange">Over Payment</ph-badge>
            </div>
        </ph-fact>
        <ph-fact>
            <ph-label>Payment Date</ph-label>
            <div>{{ data.scheduledPaymentDate ? (data.scheduledPaymentDate | legfiDate:'MM/DD/YYYY') : '--' }}</div>
        </ph-fact>
    </ph-facts>

    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="filled" (click)="_dialogRef.close()">Cancel</ph-button>
        <ph-button (click)="confirmDecisionAction()">{{ data.buttonText }}</ph-button>
    </ph-actions>
</ph-dialog>
